import clsx from 'clsx';
import { EnterByPostBlurb } from 'components/enter2026/EnterByPostBlurb';

import styles from './PostalEntrySlidingModal.module.css';
import SlidingModal, { Props as SlidingModalProps } from './SlidingModal';

interface Props extends SlidingModalProps {}

const PostalEntrySlidingModal = (props: Props) => {
  return (
    <SlidingModal {...props}>
      <EnterByPostBlurb
        headingClassName={clsx('daymadeTypographyMBlack', styles.heading)}
        headingText="Postal entry"
        paragraphClassName={clsx('daymadeTypographySRegular', styles.paragraph)}
        addressClassName={clsx('daymadeTypographySMedium', styles.address)}
      />
    </SlidingModal>
  );
};

export default PostalEntrySlidingModal;
